import Vue from "vue";
import Router from "vue-router";
import { Article, Login, Admin, Board, ArticleList, ArticleTrash, CommentList, JiwaiList } from "views";
import { ACCESS_TOKEN } from "./store/mutation-types";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/admin",
            name: "admin",
            redirect: "/admin/board",
            component: Admin,
            children: [
                {
                    path: "board",
                    component: Board
                },
                {
                    path: "article",
                    component: Article
                },
                {
                    path: "article-list",
                    component: ArticleList
                },
                {
                    path: "article-trash",
                    component: ArticleTrash,
                    props: {
                        trash: true
                    }
                },
                {
                    path: "article/:id",
                    component: Article
                },
                {
                    path: "comment-list",
                    component: CommentList
                },
                {
                    path: "jiwai-list",
                    component: JiwaiList
                }
            ]
        },
        {
            path: "/login",
            name: "login",
            component: Login
        }
    ]
});

const BLOG_NAME = "丁丁的博客";
const ACCESS_REG = /^\/admin(\/.*)?$/;

//beforeEach是router的钩子函数，在进入路由前执行
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        //判断是否有标题
        document.title = BLOG_NAME + "-" + to.meta.title;
    } else {
        document.title = BLOG_NAME;
    }

    if (ACCESS_REG.test(to.path)) {
        //console.log("reg match");
    }

    if (ACCESS_REG.test(to.path) && !Vue.ls.get(ACCESS_TOKEN)) {
        //console.log("redirect login.");
        next({ path: "/login" });
    } else {
        //console.log("not redirect login.");
        next();
    }
});

export default router;
